import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuth } from "../../BaseQueryWithAuth/baseQueryWithAuth";
import { queryParams } from "../../../utils/helper";

export const homefeaturedcontrolApiService = createApi({
  reducerPath: "homefeaturedcontrolApi",
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    getFeature: builder.query({
      query: (args) => {
        let { id, params } = args;
        let query = queryParams(params);
        if (id) {
          return `feature/${id}${query}`;
        }
        return `feature/get${query}`;
      },
    }),
  }),
});

export const { useGetFeatureQuery } = homefeaturedcontrolApiService;
